import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const StickyMobileCTA = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-border/60 bg-background/95 backdrop-blur-md px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-[0_-8px_24px_-8px_rgba(0,0,0,0.15)]">
      <div className="flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold leading-tight truncate">{t('landing.heroCta')}</p>
          <p className="text-[11px] text-muted-foreground truncate">{t('landing.stickyCtaMsg')}</p>
        </div>
        <Button
          size="sm"
          className="min-h-[48px] rounded-full px-5 shrink-0"
          onClick={() => navigate('/auth')}
        >
          {t('landing.getFreeBeta')}
          <ArrowRight className="ms-1 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
